// PPS project statuses and BCS project status have different IDs
// This must match the dbo.Entity table ID
export enum ProjectStatuses{
  Quoted = 4,
  Approved = 5,
  POReceived = 6, 
  JobLost = 7,
  RFQ = 8,
  JobCancelled = 9,
  PRFRaised = 10
}